import adminService from '../admin/index.js'

// 商户管理API - 真实API版本
export const merchantApi = {
  // 获取商户列表
  getMerchants(params) {
    console.log('获取商户列表，参数:', params)
    const { page = 1, size = 10, status, name, location } = params || {}
    
    const queryParams = {}
    if (page) queryParams.page = page
    if (size) queryParams.size = size
    if (status) queryParams.status = status
    if (name) queryParams.name = name
    if (location) queryParams.location = location
    
    return adminService.get('/admin/merchants', { params: queryParams }).then(response => {
      return {
        code: 200,
        message: '成功',
        data: {
          list: response?.data || [],       // API返回的是data字段
          total: response?.total || 0,
          page: parseInt(response?.page) || 1,
          size: parseInt(response?.limit) || 10
        }
      }
    }).catch(error => {
      console.error('获取商户列表失败:', error)
      // 检查是否是认证错误
      if (error.response?.status === 401) {
        return {
          code: 401,
          message: error.response?.data?.message || '认证失败，请重新登录',
          data: null
        }
      }
      return {
        code: error.response?.status || 500,
        message: error.response?.data?.message || '获取商户列表失败',
        data: null
      }
    })
  },

  getMerchantById(id) {
    console.log('获取商户详情，ID:', id)
    return adminService.get(`/admin/merchants/${id}`).then(response => {
      return {
        code: 200,
        message: '成功',
        data: response
      }
    }).catch(error => {
      console.error('获取商户详情失败:', error)
      return {
        code: error.response?.status || 500,
        message: error.response?.data?.message || '获取商户详情失败',
        data: null
      }
    })
  },

  // 创建商户
  createMerchant(data) {
    console.log('创建商户，数据:', data)
    return adminService.post('/admin/merchants', data).then(response => {
      return {
        code: 200,
        message: '创建成功',
        data: response
      }
    }).catch(error => {
      console.error('创建商户失败:', error)
      return {
        code: error.response?.status || 500,
        message: error.response?.data?.message || '创建商户失败',
        data: null
      }
    })
  },

  // 更新商户
  updateMerchant(id, data) {
    console.log('更新商户，ID:', id, '数据:', data)
    return adminService.put(`/admin/merchants/${id}`, data).then(response => {
      return {
        code: 200,
        message: '更新成功',
        data: response
      }
    }).catch(error => {
      console.error('更新商户失败:', error)
      return {
        code: error.response?.status || 500,
        message: error.response?.data?.message || '更新商户失败',
        data: null
      }
    })
  },

  // 删除商户
  deleteMerchant(id) {
    console.log('删除商户，ID:', id)
    return adminService.delete(`/admin/merchants/${id}`).then(response => {
      return {
        code: 200,
        message: '删除成功'
      }
    }).catch(error => {
      console.error('删除商户失败:', error)
      return {
        code: error.response?.status || 500,
        message: error.response?.data?.message || '删除商户失败'
      }
    })
  },

  // 更新商户状态
  updateMerchantStatus(id, status) {
    console.log('更新商户状态，ID:', id, '状态:', status)
    return adminService.put(`/admin/merchants/${id}/status`, { status }).then(response => {
      return {
        code: 200,
        message: '状态更新成功',
        data: response
      }
    }).catch(error => {
      console.error('更新商户状态失败:', error)
      return {
        code: error.response?.status || 500,
        message: error.response?.data?.message || '更新商户状态失败',
        data: null
      }
    })
  },

  // 获取商户统计
  getMerchantStats() {
    console.log('获取商户统计')
    return adminService.get('/admin/merchants/stats').then(response => {
      return {
        code: 200,
        message: '成功',
        data: response
      }
    }).catch(error => {
      console.error('获取商户统计失败:', error)
      return {
        code: error.response?.status || 500,
        message: error.response?.data?.message || '获取商户统计失败',
        data: null
      }
    })
  }
}

export default merchantApi
